import React, { FunctionComponent } from 'react';

import { simpleMenuAnimation } from '../../animation/menuAnimation';
import { useIsNewUiEnabled } from '../../hooks/useIsNewUiEnabled';

import { $MenuContainer, $MenuTransition } from './Menu.styles';
import { MENU_POSITIONS } from './Menu.types';

interface MenuAnimatorProps {
  position?: MENU_POSITIONS | { top: string; left: string };
  dataTestId?: string;
  componentThemeName?: string;
  minWidth?: number;
}
const MenuAnimator: FunctionComponent<
  React.PropsWithChildren<MenuAnimatorProps>
> = ({ position, dataTestId, children, componentThemeName, minWidth }) => {
  const isNewUiEnabled = useIsNewUiEnabled();

  return (
    <$MenuContainer $position={position}>
      <$MenuTransition
        $position={position}
        data-testid={dataTestId}
        $componentThemeName={componentThemeName}
        $isNewUiEnabled={isNewUiEnabled}
        $minWidth={minWidth}
        {...simpleMenuAnimation}
      >
        {children}
      </$MenuTransition>
    </$MenuContainer>
  );
};

export default MenuAnimator;
